import React from 'react'
import BaseGlobalStyles from 'src/style/baseGlobalStyles'
import GlobalFonts from 'src/style/globalFonts'

export default function GlobalStyles(): React.ReactElement {
  return (
    <>
      <GlobalFonts />
      <BaseGlobalStyles />
    </>
  )
}
